/*
 * @Author: Huangxianlong
 * @Date: 2023-10-19 09:27:10
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-06-21 09:58:26
 * @FilePath: \monitor\src\store\modules\user.js
 * @Description: 
 */
import Cookies from 'js-cookie';
import * as api from '../../api';
import { router } from '../../router/index';

const user = {
  state: {

    userInfos: {},
    cfgProjects: [],
    nocfgProjects: []
  },
  mutations: {
    LOGINOUT(state, vm) {
      Cookies.remove(serverConfig.language == "EN"?"user-en":"user-cn");
      Cookies.remove('password');
      Cookies.remove('access');
    },
    LOGIN(state) {
      //Cookies.set('user', state.userInfos.);
      //Cookies.set('password', this.form.password);

    },
    GETUSERINFOS(state, data) {
      state.userInfos = data
    },
    GETUSERPROJECT(state, data) {
      state.cfgProjects = data.cfg;
      state.nocfgProjects = data.nocfg;
    }
  },
  getters: {
    getUserInfos(state) {
      return state.userInfos;
    },
    getcfgProjects(state) {
      return state.cfgProjects;
    },
    getnocfgProjects(state) {
      return state.nocfgProjects;
    },
  },
  actions: {

    //为什么要在这里做login 或者logOut操作？
    //loginAction({ commit }, params){
    //    console.log('login.....' + params);
    //    if (params ==='loginout'){
    //        commit("LOGINOUT");
    //        console.log(router);
    //        router.push({
    //            name: 'login'
    //        });
    //    }
    //
    //    //if (params === 'loginout') {
    //    //    api.loginIn(params).then(function (response) {
    //    //        commit("LOGIN");
    //    //        console.log(response);
    //    //
    //    //    }, function (response) {
    //    //        console.log("==error==", response);
    //    //    });
    //    //}
    //},
    getUserInfosAction({ commit }, params) {
      return api.getUserInfosResource(params).then(function (response) {
        commit("GETUSERINFOS", response.body);
        return response.body;
      }, function (response) {
        console.log("==error==", response);
        return response;
      });
    },
    getUserProjectAction({ commit }, userId) {
      return api.getUserProjectResource(userId).then(function (response) {
        commit("GETUSERPROJECT", response.body);
        return response;
      }, function (response) {
        console.log("==error==", response);
        return response;
      });
    },
    saveUserProjectAction({ commit }, params) {
      return api.saveUserProjectResource(params.keys, params.userId, params.manageUser).then(function (response) {
        commit("GETUSERPROJECT", response.body);
        return response;
      }, function (response) {
        console.log("==error==", response);
        return response;
      });
    },
    saveUserStatusAction({ commit }, params) {
      return api.saveUserStatusResource(params.userId, params.status).then(function (response) {
        return response.body;
      }, function (response) {
        console.log("==error==", response);
        return response.body;
      });
    },
    saveUserInfoAction({ commit }, params) {
      const _this = this;
      api.saveUserInfo(params).then(function (response) {
        alert(response.body.msg);
      }, function (response) {
        console.log("==error==", response);
      });
    }

  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js